import { render, staticRenderFns } from "./CompanyWebsiteUrlSettings.vue?vue&type=template&id=42d7c7ff&"
import script from "./CompanyWebsiteUrlSettings.vue?vue&type=script&lang=ts&"
export * from "./CompanyWebsiteUrlSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports